export const LEAD_CAPTURE_CONTACT_STORAGE_KEY = 'lead_capture_contact';

export type LeadCaptureContact = { email: string; phone?: string } | null;
